import { Size } from "@repo/ui/helpers/helpers";
import { entityTable } from "@repo/ui/tables/entityTable";
import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface SettingsTableDataCellProps {
  className?: string;
  children: ReactNode;
}

export const SettingsTableDataCell: FC<SettingsTableDataCellProps> = (
  props,
) => (
  <td
    className={entityTable({ size: Size.SMALL }).cell({
      className: twMerge("text-foreground", props.className),
    })}
  >
    {props.children}
  </td>
);
